import getConfig from 'next/config';
import * as Sentry from '@sentry/node';
import { RewriteFrames } from '@sentry/integrations';
import { Integrations as TracingIntegrations } from '@sentry/tracing';

// https://github.com/vercel/next.js/tree/canary/examples/with-sentry
export const initSentry = () => {
    if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
        const integrations = [];
        if (process.env.NEXT_IS_SERVER === 'true') {
            const config = getConfig();
            const distDir = `${config.serverRuntimeConfig.rootDir}/.next`;
            // For Node.js, rewrite Error.stack to use relative paths, so that source
            // maps starting with ~/_next map to files in Error.stack with path
            // app:///_next
            integrations.push(
                new RewriteFrames({
                    iteratee: (frame) => {
                        if (frame.filename !== undefined) {
                            frame.filename = frame.filename.replace(
                                distDir,
                                'app:///_next',
                            );
                        }
                        return frame;
                    },
                }),
            );
        } else {
            integrations.push(new TracingIntegrations.BrowserTracing());
        }
        Sentry.init({
            enabled: process.env.NODE_ENV === 'production',
            tracesSampleRate: 1.0,
            dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
            release: process.env.NEXT_PUBLIC_BUILD_ID,
            integrations: integrations,
            environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
        });
    }
};
